import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import UpdateDistrictDTO from '../models/district/UpdateDistrictDTO';
import DistrictDTO from '../models/district/DistrictDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import DistrictFullSyncDTO from '../models/district/DistrictFullSyncDTO';
import AddDistrictDTO from '../models/district/AddDistrictDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';
import BulkUpdateDistrictSyncDTO from '../models/district/BulkUpdateDistrictSyncDTO';
import DistrictSyncStatusDTO from '../models/district/DistrictSyncStatusDTO';

export class DistrictApiController {
    // post: District/AddDistrict
    public RouteAddDistrict = () => `District/AddDistrict`;
    public addDistrict(addDistrictDTO: AddDistrictDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAddDistrict();
        return HttpApi.RestRequest<any, void>(addDistrictDTO, 'post', url, requestOptions);
    }
    // post: District/UpdateDistrict
    public RouteUpdateDistrict = () => `District/UpdateDistrict`;
    public updateDistrict(updateDistrictDTO: UpdateDistrictDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateDistrict();
        return HttpApi.RestRequest<any, void>(updateDistrictDTO, 'post', url, requestOptions);
    }
    // get: District/GetDistrict/${districtId}
    public RouteGetDistrict = (districtId: number) => `District/GetDistrict/${districtId}`;
    public getDistrict(districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateDistrictDTO>> {
        let url = this.RouteGetDistrict(districtId);
        return HttpApi.RestRequest<any, UpdateDistrictDTO>(null, 'get', url, requestOptions);
    }
    // get: District/GetDistrictForSso/${districtId}
    public RouteGetDistrictForSso = (districtId: number) => `District/GetDistrictForSso/${districtId}`;
    public getDistrictForSso(districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<DistrictDTO>> {
        let url = this.RouteGetDistrictForSso(districtId);
        return HttpApi.RestRequest<any, DistrictDTO>(null, 'get', url, requestOptions);
    }
    // get: District/GetAllDistricts
    public RouteGetAllDistricts = () => `District/GetAllDistricts`;
    public getAllDistricts(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllDistricts();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: District/GetAllDistricts/${stateId}
    public RouteGetAllDistrictsByState = (stateId: number) => `District/GetAllDistricts/${stateId}`;
    public getAllDistrictsByState(stateId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllDistrictsByState(stateId);
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // post: District/GetDistrictTableData
    public RouteGetDistrictTableData = () => `District/GetDistrictTableData`;
    public getDistrictTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<DistrictDTO>>> {
        let url = this.RouteGetDistrictTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<DistrictDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: District/GetDistrictFullSyncTableData?districtId=${districtId}
    public RouteGetDistrictFullSyncTableData = (districtId: number) => `District/GetDistrictFullSyncTableData?districtId=${districtId}`;
    public getDistrictFullSyncTableData(tableRequest: TableRequestDTO, districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<DistrictFullSyncDTO>>> {
        let url = this.RouteGetDistrictFullSyncTableData(districtId);
        return HttpApi.RestRequest<any, TableResponseDTO<DistrictFullSyncDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: District/GetFullSyncsByDistrictId?districtId=${districtId}
    public RouteGetFullSyncsByDistrictId = (districtId: number) => `District/GetFullSyncsByDistrictId?districtId=${districtId}`;
    public getFullSyncsByDistrictId(districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<DistrictFullSyncDTO[]>> {
        let url = this.RouteGetFullSyncsByDistrictId(districtId);
        return HttpApi.RestRequest<any, DistrictFullSyncDTO[]>(null, 'get', url, requestOptions);
    }
    // get: District/GetAllDistrictsWithSyncStatus
    public RouteGetAllDistrictsWithSyncStatus = () => `District/GetAllDistrictsWithSyncStatus`;
    public getAllDistrictsWithSyncStatus(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<DistrictSyncStatusDTO[]>> {
        let url = this.RouteGetAllDistrictsWithSyncStatus();
        return HttpApi.RestRequest<any, DistrictSyncStatusDTO[]>(null, 'get', url, requestOptions);
    }
    // post: District/BulkUpdateCleverSync
    public RouteBulkUpdateCleverSync = () => `District/BulkUpdateCleverSync`;
    public bulkUpdateCleverSync(dto: BulkUpdateDistrictSyncDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteBulkUpdateCleverSync();
        return HttpApi.RestRequest<any, void>(dto, 'post', url, requestOptions);
    }
    // post: District/BulkUpdateClassLinkSync
    public RouteBulkUpdateClassLinkSync = () => `District/BulkUpdateClassLinkSync`;
    public bulkUpdateClassLinkSync(dto: BulkUpdateDistrictSyncDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteBulkUpdateClassLinkSync();
        return HttpApi.RestRequest<any, void>(dto, 'post', url, requestOptions);
    }
    // post: District/BulkUpdateDistrictSync
    public RouteBulkUpdateDistrictSync = () => `District/BulkUpdateDistrictSync`;
    public bulkUpdateDistrictSync(dto: BulkUpdateDistrictSyncDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteBulkUpdateDistrictSync();
        return HttpApi.RestRequest<any, void>(dto, 'post', url, requestOptions);
    }
}
var service = new DistrictApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/DistrictApiController.ts